import SearchFilterRequest from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/Common/SearchFilterRequest";
import FilterRequest from "@/api/dataSource/api/Spirit/Common/Extensions/Models/FilterRequest";
import SearchRequest from "@/api/dataSource/api/Spirit/Common/Extensions/Models/SearchRequest";
import IFilterModel from "../IFilterModel";



export default class InspirationFilterModel implements IFilterModel {
    search: string = '';
    resetToDefault() {
        this.search = '';
    }
    toSearchRequest(): SearchRequest[] {
        const res = new Array<SearchRequest>();
        // this.search && res.push(new SearchRequest({FieldName: 'Search', SearchValue: this.search}));
        return res;
    }
    toFilterRequest(): SearchFilterRequest {
        const res = new SearchFilterRequest({
            Name: this.search
        });
        res.Search = this.toSearchRequest();
        return res;
    }
}